import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { AiFillCaretRight, AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

const HouseOwnersInsurance = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/HouseownersInsurance.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "Residential properties used for domestic purposes excluding contents";

  
  const [openIndex, setOpenIndex] = useState(null);


  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "Features",
      content: [
        "Riot and civil commotion (non-political)",
        "Fire Brigade Charges – 10% of the sum insured",
        "Loss of rent receivable following an insured peril – Three (3) months limited to K4,000.00 per month",
        "Site clearance of debris –10% of claim subject to a maximum of ZMW150,000.00 or USD 15,000.00",
        "Bush fire cover",
        "Unoccupancy 60 days",
        "10% Minimum K500.00 each and every claim including theft claims",
        "Double excess for fall from height claims"
      ],
    },
    {
      title: "Requirements Before Cover Is Confirmed",
      content: [
        "Physical address of the property to be covered",
        "Right rebuilding cost supported by a valuation report"
      ],
    },
    {
      title: "Basis of cover",
      content: [
        "Damage to the insured property due to fire, lightning, explosion, earthquake, riot, civil commotion, strike, theft or any attempt thereat, storm tempest, flood, bursting or overflowing of pipes or apparatus, accidental damage etc",
      ],
    },
    {
      title: "Settlement",
      content: ["Rebuilding cost or reinstatement value."],
    },
    {
      title: "Some Notable Exclusions Among Others",
      content: [
        "Damage to property outside the occupancy period",
        "Consequential loss",
        "Political, terrorism and war risks",
        "Willful acts",
        "Subsistence or landslide"
      ],
    },
    {
      title: "How to Apply",
      content: ['To apply now, email <a href="mailto:bancassurance@izb.co.zm">bancassurance@izb.co.zm</a> or call <a href="tel:8002">8002</a>'],
    }
  ];

  return (
    <>
       <section className="HouseOwnersInsuranceSection">
        <Breadcrumb Heading="House Owners Insurance" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
       </section>

       <SavePlusAccountComponent heading="House Owners Insurance" subHeading="Know About" btnTxt="Apply Now" content={accountContent} img={img1} logo={true} />
       {/* <ContainsArea /> */}

        <section>
            <div className="container">
            <div className="row">
                <div className="col-xl-12 justify-content-center">
                <div className="faq-style1__content">
                    <ul className="accordion-box mt-2" style={{paddingBottom: "50px"}}>
                        {accordionData.map((item, index) => (
                            <li className="accordion block active-block" key={index}>
                                <div
                                    className="acc-btn active"
                                    style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                    onClick={() => handleToggle(index)}
                                >
                                    <div className="icon-outer text-white">
                                        {openIndex === index ? <AiOutlineArrowRight /> : <AiOutlineArrowUp />}
                                    </div>
                                    <h3 className="text-white">{item.title}</h3>
                                </div>
                                {openIndex === index && (
                                    <div className="acc-content current px-5">
                                        {item.content.map((point, idx) => (
                                            <p key={idx} className="">
                                                <AiFillCaretRight className="me-1 accordion-icon" />
                                                <span className="mt-1" dangerouslySetInnerHTML={{ __html: point }} />
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                </div>
            </div>
            </div>
        </section>

       <AllAcountsSection />
    </>
  );
};

export default HouseOwnersInsurance;